import { Popconfirm, Space, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg, TrashSvg } from "src/components/Svg"
import styled from "styled-components"

export function getColumns(onEdit, onDelete) {
    return [
        {
            width: 80,
            title: "ID",
            dataIndex: "id",
            key: "id",
            sorter: (a, b) => a.id - b.id,
            defaultSortOrder: "ascend",
        },
        {
            title: "Название",
            dataIndex: "nameRu",
            key: "name",
            sorter: (a, b) => a.name - b.name,
        },
        {
            title: "Вирт. категории",
            dataIndex: "vCategories",
            key: "vCategories",
            render: (data) =>
                data.map((item, i) => (
                    <StyledTag key={`vCategoryTag_${i}`} color={"default"} >
                        {item}
                    </StyledTag>
                )),

        },
        {
            title: "Продуктовая категория",
            dataIndex: "productCategories",
            key: "productCategories",
            render: (data) =>
                data.map((item, i) => (
                    <StyledTag key={`productCategoryTag_${i}`} color={"default"} >
                        {item}
                    </StyledTag>
                )),
        },
        {
            width: 100,
            title: "Включен",
            dataIndex: "isActive",
            key: "isActive",
            render: (text) => (
                <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
                    {text ? "ДА" : "НЕТ"}
                </StyledTag>
            ),
        },
        {
            width: 100,
            title: "Показывать на главной",
            dataIndex: "isShowToMain",
            key: "isShowToMain",
            render: (text) => (
                <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
                    {text ? "ДА" : "НЕТ"}
                </StyledTag>
            ),
        },
        ...(onEdit || onDelete ? [{
            width: 100,
            title: "Действие",
            key: "action",
            render: (_, record) => (
                <Space size="small">
                    {onEdit && (
                        <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
                            <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                                <PencilSvg />
                            </Button>
                        </Tooltip>
                    )}
                    {onDelete && (
                        <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
                            <Popconfirm
                                placement="left"
                                title="Действительно хотите удалить?"
                                onConfirm={() => onDelete(record.id)}
                                onCancel={() => stopPropagation}
                            >
                                <Button size="small" type="link" onClick={stopPropagation}>
                                    <TrashSvg />
                                </Button>
                            </Popconfirm>
                        </Tooltip>
                    )}
                </Space>
            ),
        }] : []),
    ]
}

const stopPropagation = (e) => {
    e?.stopPropagation()
}

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`
